import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import { RouteWithLayout } from 'components';
import {
   Desktop as Main, Mobile as Minimal,
} from 'layouts';

import NotFound from 'components/module-login/views/NotFound/NotFound';
import Homepage from 'components/module-login/views/Homepage/homepage';

import PrivateRoute from 'components/private-route/private-route';

import Dashboard from 'views/Dashboard/Dashboard';

import ChangeLog from 'views/Change-Log/change-log';

                // import BHTsInsuranceProviderListContainer from "containers/x-containers-bhts-insurance-provider";
import BOPInstitutionListContainer from "containers/containers-bop-institutions";
import GangAffiliationListContainer from "containers/containers-gang-affiliations";

import ReferralSourcesListContainer from "containers/containers-referral-sources";

import ReferralListContainer from "containers/containers-referrals";
import ReferralAddContainer from "containers/containers-referral-add";
import ReferralEditContainer from "containers/containers-referral-edit";

import ClientEditContainer from 'containers/containers-client-edit';
import ClientListContainer from 'containers/containers-clients';

import PostDischargeEditContainer from 'containers/containers-postdischarge-edit';
import PostDischargeListContainer from 'containers/containers-postdischarges';
import PostDischarge90dListContainer from 'containers/containers-postdischarges90d';
import PostDischarge180dListContainer from 'containers/containers-postdischarges180d';

import PostDischarge12mListContainer from 'containers/containers-postdischarges12m';
import PostDischarge24mListContainer from 'containers/containers-postdischarges24m';
import PostDischarge36mListContainer from 'containers/containers-postdischarges36m';

import ArchivedReferralListContainer from "containers/containers-archived-referrals";
import ArchivedReferralViewContainer from "containers/containers-archived-referrals-view";

import ArchivedClientListContainer from "containers/containers-archived-clients";
import ArchivedClientViewContainer from "containers/containers-archived-clients-view";

import ArchivedPostDischargeListContainer from "containers/containers-archived-postdischarges";
import ArchivedPostDischargeViewContainer from "containers/containers-archived-postdischarges-view";



/*** components/module-login */
import LoginsAdd from 'components/module-login/views/Logins-Add-Edit/login-add'
import LoginsEdit from 'components/module-login/views/Logins-Add-Edit/login-edit';
import LoginsList from "components/module-login/views/Logins/logins";

// import LoginRolesList from "components/module-login/views/LoginRoles/loginroles";

import Settings from 'components/module-login/views/PasswordReset/password-reset'
import Register from 'components/module-login/views/Register/Register';
import SignIn from 'components/module-login/views/SignIn/SignIn';
import SignOut from 'components/module-login/views/SignOut/SignOut';
/*** components/module-login */







              // import ReportsContainer from "containers/containers-reports";
              // import ReportsView from "views/Reports/reports";


import Report1Container from 'containers/containers-reports1';


import SampleReportsPage1 from 'views/sample-reports-page/SampleReportsPage1';
import DashboardCountsContainer from 'containers/containers-reports-dashboard-counts';
                // import DashboardCounts from 'views/DashboardCounts/DashboardCounts';
import ProgramCountsContainer from 'containers/containers-reports-programs-counts';





const Routes = () => {
  return (
    <Switch>
      <Redirect
        exact
        from="/"
        to='/dashboard'
      />


      <PrivateRoute 
        
                                          // requiredRole='2'
        requiredRole='1'
        component={Dashboard}
        path="/dashboard"
        layout={Main}
        exact
      />

      <PrivateRoute 
        
        requiredRole='2'
        component={Report1Container}
        path="/reports1"
        layout={Main}
        exact
      />

      <PrivateRoute 
              
              // requiredRole='2'
        requiredRole='3'
        component={ChangeLog}
        path={'/changelog'}
        layout={Main}
        exact
      />




                                                  {/* 
                                                        <PrivateRoute 
                                                          
                                                          requiredRole='2'
                                                          // component={ReportsContainer}
                                                          component={ReportsView}
                                                          path="/reports"
                                                          layout={Main}
                                                          exact
                                                        /> 
                                                  */}


                                                  {/* 
                                                        <Route 
                                                          path='/reports' 
                                                          component={() => { 
                                                          window.location.replace = {ReportsView}; 
                                                          return null;
                                                        }}/>
                                                  */}


                                                  {/* 
                                                        <Route 
                                                          path='/reports' 
                                                          component={() => { 
                                                            window.location.href = process.env.REACT_APP_REPORTS_URL; 
                                                            return null;
                                                          }}
                                                        />
                                                  */}



      <PrivateRoute 
        
        requiredRole='2'
        component={DashboardCountsContainer}
        path="/dashboardcounts"
        layout={Main}
        exact
      />

      <PrivateRoute 
        
        requiredRole='2'
        component={ProgramCountsContainer}
        path="/programcounts"
        layout={Main}
        exact
      />

      <PrivateRoute 
        
        requiredRole='2'
        component={SampleReportsPage1}
        path="/samplereportspage1"
        layout={Main}
        exact
      />


      <PrivateRoute 
        
        requiredRole='0'
        component={ReferralAddContainer}
        path="/referrals/add"
        layout={Main}
        exact
      />
      <PrivateRoute 
        
        requiredRole='0'
        component={ReferralEditContainer}
        path="/referrals/:id"
        layout={Main}
        exact
      />
      <PrivateRoute 
        
        requiredRole='0'
        component={ReferralListContainer}
        path="/referrals"
        layout={Main}
        exact
      />


      <PrivateRoute
        
        requiredRole='0'
        component={ClientEditContainer}
        path="/clients/:id"
        layout={Main}
        exact
      />
      <PrivateRoute 
        
        requiredRole='0'
        component={ClientListContainer}
        path="/clients"
        layout={Main}
        exact
      />


      <PrivateRoute
        
        requiredRole='0'
        component={PostDischargeEditContainer}
        path="/postdischarges/:id"
        layout={Main}
        exact
      />
      <PrivateRoute 
        
        requiredRole='0'
        component={PostDischargeListContainer}
        path="/postdischarges"
        layout={Main}
        exact
      />
      <PrivateRoute 
        
        requiredRole='0'
        component={PostDischarge90dListContainer}
        path="/postdischarges90d"
        layout={Main}
        exact
      />
      <PrivateRoute 
        
        requiredRole='0'
        component={PostDischarge180dListContainer}
        path="/postdischarges180d"
        layout={Main}
        exact
      />
      <PrivateRoute 
        
        requiredRole='0'
        component={PostDischarge12mListContainer}
        path="/postdischarges12m"
        layout={Main}
        exact
      />
      <PrivateRoute 
        
        requiredRole='0'
        component={PostDischarge24mListContainer}
        path="/postdischarges24m"
        layout={Main}
        exact
      />
      <PrivateRoute 
        
        requiredRole='0'
        component={PostDischarge36mListContainer}
        path="/postdischarges36m"
        layout={Main}
        exact
      />


      <PrivateRoute 
        
        // requiredRole='2'
        requiredRole='3'
        component={ArchivedReferralViewContainer}
        path="/archivedreferrals/:id"
        layout={Main}
        exact
      />
      <PrivateRoute 
        
        // requiredRole='2' 
        requiredRole='3' 
        component={ArchivedReferralListContainer}
        path="/archivedreferrals"
        layout={Main}
        exact
      />


      <PrivateRoute 
        
        // requiredRole='2'
        requiredRole='3'
        component={ArchivedClientViewContainer}
        path="/archivedclients/:id"
        layout={Main}
        exact
      />
      <PrivateRoute 
        
        // requiredRole='2' 
        requiredRole='3' 
        component={ArchivedClientListContainer}
        path="/archivedclients"
        layout={Main}
        exact
      />


      <PrivateRoute 
        
        // requiredRole='2'
        requiredRole='3'
        component={ArchivedPostDischargeViewContainer}
        path="/archivedpostdischarges/:id"
        layout={Main}
        exact
      />
      <PrivateRoute 
        
        // requiredRole='2'
        requiredRole='3'
        component={ArchivedPostDischargeListContainer}
        path="/archivedpostdischarges"
        layout={Main}
        exact
      />
                                                                
                                                          {/* 
                                                                <PrivateRoute 
                                                                  
                                                                  requiredRole='2'
                                                                  component={BHTsInsuranceProviderListContainer}
                                                                  path="/bhtsinsuranceproviders"
                                                                  layout={Main}
                                                                  exact
                                                                />
                                                          */}

      <PrivateRoute 
        
        requiredRole='2'
        component={BOPInstitutionListContainer}
        path="/bopinstitutions"
        layout={Main}
        exact
      />
      <PrivateRoute 
        
        requiredRole='2' 
        component={GangAffiliationListContainer}
        path="/gangaffiliations"
        layout={Main}
        exact
      />
      <PrivateRoute 
        
        requiredRole='2'
        component={ReferralSourcesListContainer}
        path="/referralsources"
        layout={Main}
        exact
      />



      <PrivateRoute 
        
        requiredRole='3'
        component={LoginsList}
        path="/logins"
        layout={Main}
        exact
      />
      <PrivateRoute 
        
        requiredRole='3'
        component={LoginsAdd}
        path="/logins/add"
        layout={Main}
        exact
      />
      <PrivateRoute 
        
        requiredRole='3'
        component={LoginsEdit}
        path="/logins/:id"
        layout={Main}
        exact
      />

      <PrivateRoute
        
        requiredRole='0'
        component={Settings}
        path="/settings"
        layout={Main}
        exact
      />
      <RouteWithLayout
                                                                                        // component={SignOutView}
        component={SignOut}
        path="/sign-out"
        layout={Minimal}
        exact
      />
      <RouteWithLayout
        component={SignIn}
        path="/sign-in"
        layout={Minimal}
        exact
      />
      <RouteWithLayout
        component={Register}
        path="/register"
        layout={Minimal}
        exact
      />
      <PrivateRoute 
        
        requiredRole='0'         
        component={Homepage}
        path="/home"
        layout={Main}
        exact
      />
      <PrivateRoute 
        
        requiredRole='0'         
        component={NotFound}
        path="/not-found"
        /*** with toolbar */
        layout={Main}
        /*** no toolbar */
                                                                                      // layout={Minimal}
        exact
      />
      <Redirect to="/not-found" />
    </Switch>
  );
};
export default Routes;